<template>
  <i
    :class="icon"
    :style="iconStyle"
  />
</template>
<script>
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
    },
    color: {
      type: String,
    },
    width: {
      type: Number,
    },
  },
  computed: {
    iconStyle() {
      return {
        fontSize: `${this.size}px`,
        color: this.color,
        width: `${this.width}px`,
        textAlign: 'center',
      };
    },
  },
};
</script>
<style>

</style>
